import {
  WSActions,
  WSCard,
  WSEmptyState,
  WSList
} from "@wingspanhq/fe-component-library";
import React from "react";

import { WSQueries } from "../../../../query/WSQuery";
import { useQueryRequirementDefinition } from "../../../../query/requirementDefinitions/query/useQueryRequirementDefinition";
import { StepComponentProps } from "../../../../shared/components/ModalFlow/types";
import { useRequirementDefinitionSettings } from "../../hooks/useRequirementDefinitionSettings";
import { getRequirementDefinitionTemplate } from "../../utils/getRequirementDefinitionTemplate";

import { FlowCreateNewVersionState } from "./types";

export const SuccessStep: React.FC<
  StepComponentProps<FlowCreateNewVersionState>
> = ({ onBack, onSuccess, state }) => {
  const queryRequirementDefinition = useQueryRequirementDefinition(
    state.requirementDefinitionId
  );

  const querySettingsItem = useRequirementDefinitionSettings({
    dataSourceId: queryRequirementDefinition.data?.dataSourceId,
    requirementType: queryRequirementDefinition.data?.requirementType
  });

  return (
    <WSQueries queries={{ queryRequirementDefinition, querySettingsItem }}>
      {({ queryRequirementDefinitionData, querySettingsItemData }) => {
        const template = getRequirementDefinitionTemplate(
          queryRequirementDefinitionData,
          querySettingsItemData
        );

        const name = queryRequirementDefinitionData.name || template.name;
        const version = queryRequirementDefinitionData.version;

        return (
          <WSList gap="2XL">
            <WSCard>
              <WSEmptyState
                description={`A new version of the requirement was created successfully.`}
                orientation="horizontal"
                title={`${name} v${version} created`}
                type="done"
              />
            </WSCard>

            <WSActions
              alignment="fill"
              buttons={[
                {
                  label: "Continue",
                  onAsyncClick: async () => {
                    onSuccess();
                  }
                }
              ]}
            />
          </WSList>
        );
      }}
    </WSQueries>
  );
};
